import axios_nomura from './axios-nomura.services';

export const fetchCompareFunds = async (data) => {
  return await axios_nomura.get(`/api/v1/fundcompare`, { params: { fundIds: data }});
};

export const fetchCompareFundsByPeriod = async (data) => {
  return await axios_nomura.get(`/api/v1/fundcompare/other`, { params: { fundIds: data.fundIds, type: data.type } })
};

export const fetchGraphCompareFunds = async (data) => {
  return await axios_nomura.get(`/api/v1/fundcompare/graph`,
    { params: {startDate: data.startDate ?? '', endDate: data.endDate ?? '', mode: data.mode, fundIds: data.body } }
  );
};
